import { defaultLocalisation } from './localisationDefaults';
import Localisation from '../interfaces/localisation'
import { store } from '../Redux/store'
import { fetchLocalisation } from '../Redux/slices/localisationSlice';

interface LanguageDictionary {
    [key: string]: string
}

const localisation = {

    languageDictionary: <LanguageDictionary> {...defaultLocalisation},
    language: window.navigator.language,

    setup(){

        this.language = window.navigator.language;
        this.languageDictionary = {...defaultLocalisation};

        return this.setUpLanguageDictionary();
    },

    setUpLanguageDictionary() {

        const {status, language} = store.getState().localisation;

        if (status === 'idle' || (status === 'succeeded' && language !== navigator.language)) {
            store.dispatch(fetchLocalisation());
        }

        return;
    },

    getLocalString(key: Localisation, replacements?: string []): string {
        /**
         * Add keys and values to localisationDefaults.ts for fallbacks
        */

        const { languageDictionary } = store.getState().localisation;
        
        let string = languageDictionary[key]
        
        if (string && replacements?.length) {
            string = this.interpolate(string, replacements)
        }

        if (string === ""){
            console.error("Missing localisation string:" + key)
        }

        if (string && string.includes('[strong]')) {
            string = this.emphasis(string, 'strong', 'strong');
            
        }

        if (string && string.includes('[underline]')) {
            string = this.emphasis(string, 'underline', 'u');
            
        }

        if(string && string.includes('[break][/break]')) {
            string = string.split('[break][/break]').join('<br />');
        }
        
        return string;
    },

    interpolate(string: string, replacements: string[]) {
        for (const [idx, value] of Array.from(replacements.entries())) {
            const ref = `{${idx}}`
            string = string.split(ref).join(value);
        }
        return string
    },

    emphasis(string: string, placeholder: string, replacementTag: string): string {
        const openingTag = new RegExp(`\\[${placeholder}]`);
        const closingTag =  new RegExp(`\\[/${placeholder}]`);
        return string
            .split(openingTag).join( "<" + replacementTag + ">")
            .split(closingTag).join("</" + replacementTag + ">");
    },

    refreshLocalistaion() {
        store.dispatch(fetchLocalisation());
    }

}

export default localisation